export const getInstitutions = state => state.institutions.institution_list;
export const getInstitutionDetail = state =>
  state.institutions.institution_detail;
export const getActiveInstitution = state => state.institutions.active;
export const getCategories = state => state.institutions.categories;
export const getDistricts = state => state.institutions.districts;
export const getUser = state => state.auth.user;
export const getUsers = state => state.auth.users;
export const getToken = state => state.auth.token;

export const isRequestingPassword = state => state.auth.requesting_password;
export const requestedPassword = state => state.auth.requested_password;
export const isResettingPassword = state => state.auth.resetting_password;
export const passwordReset = state => state.auth.password_reset;
export const resetPasswordFailed = state => state.auth.reset_password_failed;

export const saveUserFailed = state => state.auth.save_user_failed;
export const saveUserErrors = state => state.auth.save_user_errors;
export const isSavingUser = state => state.auth.saving_user;
export const savedUser = state => state.auth.saved_user;

export const isValidatingRegistration = state =>
  state.auth.validating_registration;
export const validatedRegistration = state => state.auth.validated_registration;
export const registrationValidationFailed = state =>
  state.auth.registration_validation_failed;

export const navIsOpen = state => state.gui.nav_is_open;
export const isInitializing = state => state.gui.initializing;

export const userToken = state => state.auth.token;
export const loginFailed = state => state.auth.login_failed;
export const isFetchingInstitutions = state =>
  state.institutions.fetching_institutions;
export const isFetchingInstitution = state =>
  state.institutions.fetching_institution;

export const isLoadingDistricts = state => state.institutions.loading_districts;
export const isLoadingCategories = state =>
  state.institutions.loading_categories;
export const isLoggingIn = state => state.auth.logging_in;
export const isLoadingUsers = state => state.auth.loading_users;
export const saveInstitutionFailed = state =>
  state.institutions.save_institution_failed;
export const saveInstitutionErrors = state =>
  state.institutions.save_institution_errors || {};
export const isSavingInstitution = state =>
  state.institutions.saving_institution;
export const getInstitution = (state, key) =>
  state.institutions.institution_list.find(item => item._key === key) || {};

export const isLoadingUser = state => state.auth.loading_user;
export const loadUserFailed = state => state.auth.load_user_failed;

export const getArea = (state, area_key) => {
  return (
    getDistricts(state).find(
      district => district.value === Math.round(area_key / 100)
    ) || {
      children: []
    }
  ).children.find(child => child.value === parseInt(area_key, 10));
};



/** WEBPACK FOOTER **
 ** ./src/selectors.js
 **/